export const Component = {
    Auth: {
        Login: "Login",
        Register: "Register",
        ResetPassword: "ResetPassword",
        ChangePassword: "ChangePassword"
    },
    Protected: {
        Dashboard: "Dashboard",
        Company: {
            Home: "Company",
            Info: "Info",
            General: "CompanyInfo",
            SettingList: "SettingList",
            Workflow: {
                Edit: "EditWorkflow",
                List: "ListWorkflows",
            },
            WorkflowToDos: {
                List: "ListWorkflowToDos"
            },
            Locations: {
                List: "ListLocations",
                Add: "AddLocations",
                Edit: "EditLocations"
            },
            Departments: {
                List: "ListDepartments",
                Add: "AddDepartments",
                Edit: "EditDepartments"
            },
            // MarketPlace: {
            //     List: "ListMarketplace",
            //     Add: "AddMarketplace",
            //     Edit: "EditMarketplace"
            // },
            LeaveTypes: {
                List: "ListLeaveTypes",
                Add: "AddLeaveTypes",
                Edit: "EditLeaveTypes"
            },
            Membership: {
                List: "membership"
            },
            Benefits: {
                List: "Benefits"
            },
            Calendar: {
                List: 'ListCalendars',
            },
            Access: {
                List: 'ListAccess',
                Logs: 'ListLogs',
            },
        },
        Backoffice: {
            List: 'Backoffice',
            Add: 'AddBackoffice',
            Edit: 'EditBackoffice',
            Read: 'ReadOnlyBackoffice'
        },
        Benefit: {
            Marketplace: 'BenefitMarketplace',
            List: 'Benefits',
            Add: 'createBenefit',
            // Info: 'listBenefitInfo',
            OnBoarding: 'BenefitOnBoarding',
            Pension: {
                Add: 'AddPension',
                Edit: 'EditPension',
            },
            Insurance: {
                Add: 'AddInsurance',
                Edit: 'EditInsurance',
            },
            Custom: {
                Add: 'AddCustomBenefit',
                Edit: 'EditCustomBenefit',
            },
            Provider: {
                Info: 'ProviderInfo',
                Profile: 'ProviderProfile'
            },
        },
        TimeOff: {
            List: 'ListTimeOff',
            Edit: 'DetailsTimeOff',
            Approve: 'ApproveTimeOff'
        },
        Membership: 'Membership',
        Employee: {
            Me: 'Me',
            Base: 'Employee',
            Edit: 'EditEmployee',
            Document: 'Document',
            MyBenefits: 'MyBenefits',
            // MyBenefitDetails: 'MyBenefitDetails',
            Profile: 'ProfileEmployee',
            MyTasks: 'MyTasks',
        },
        Announcement: {
            Add: "AddAnnouncement",
            Edit: "EditAnnouncement",
            List: "Announcement",
            Read: "ReadOnlyAnnouncement"
        },
    }
};